import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, Suspense as _Suspense, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["href"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = {
  key: 4,
  class: "mt-3 white-space-pre-wrap"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconPark = _resolveComponent("IconPark")!
  const _component_CampaignStatus = _resolveComponent("CampaignStatus")!
  const _component_PrimeVueSkeleton = _resolveComponent("PrimeVueSkeleton")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      (_ctx.user.isLimitedManagerByUserId(_ctx.campaign.user_id))
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.campaign.compiled_name), 1))
        : (_openBlock(), _createElementBlock("a", {
            key: 1,
            class: "text-indigo-400",
            href: `/campaigns/${_ctx.campaign.id}`,
            target: "_blank"
          }, _toDisplayString(_ctx.campaign.compiled_name), 9, _hoisted_2)),
      (_ctx.user.isStaff() && !_ctx.user.isLimitedManagerByUserId(_ctx.campaign.user_id))
        ? (_openBlock(), _createElementBlock("a", {
            key: 2,
            class: "ml-2",
            href: `/statistics/staff?filters=${_ctx.encodeStatisticsFilters({ ..._ctx.statisticsFilters, campaign_id: [_ctx.campaign.id] })}`,
            target: "_blank"
          }, [
            _withDirectives(_createVNode(_component_IconPark, {
              class: "text-blue-600 cursor-pointer",
              type: "chart-histogram-two",
              theme: "outline",
              size: "14"
            }, null, 512), [
              [
                _directive_tooltip,
                _ctx.$t('statistics'),
                void 0,
                { right: true }
              ]
            ])
          ], 8, _hoisted_3))
        : _createCommentVNode("", true),
      (!_ctx.user.isLimitedManagerByUserId(_ctx.campaign.user_id))
        ? (_openBlock(), _createBlock(_Suspense, { key: 3 }, {
            default: _withCtx(() => [
              _createVNode(_component_CampaignStatus, {
                class: "ml-2",
                "campaign-id": _ctx.campaign.id,
                "campaign-status": _ctx.campaign.status,
                "onUpdate:campaignStatus": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.campaign.status) = $event)),
                "as-icon": ""
              }, null, 8, ["campaign-id", "campaign-status"])
            ]),
            fallback: _withCtx(() => [
              _createVNode(_component_PrimeVueSkeleton, {
                width: "14px",
                height: "14px"
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (_ctx.user.isStaff())
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.campaign.bid && _ctx.campaign.payment_type === _ctx.CAMPAIGN_PAYMENT_TYPE_CPM)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, "CPM: " + _toDisplayString(_ctx.$n(_ctx.campaign.bid * 1000, 'bid')), 1))
            : (_ctx.campaign.bid)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, "CPC: " + _toDisplayString(_ctx.$n(_ctx.campaign.bid, 'bid')), 1))
              : _createCommentVNode("", true),
          (_ctx.campaign.max_spending)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('max_spending')) + ": " + _toDisplayString(_ctx.$n(_ctx.campaign.max_spending, 'payout')), 1),
                (_ctx.campaign.max_spending && _ctx.campaign.spent > _ctx.campaign.max_spending)
                  ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_7, [...(_cache[1] || (_cache[1] = [
                      _createTextVNode("⚠️", -1)
                    ]))])), [
                      [_directive_tooltip, _ctx.$t('max_spending_is_reached')]
                    ])
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.campaign.max_spending_per_day)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t('max_spending_per_day')) + ": " + _toDisplayString(_ctx.$n(_ctx.campaign.max_spending_per_day, 'payout')) + " (" + _toDisplayString(_ctx.$t(_ctx.CAMPAIGN_MAX_SPENDING_PER_DAY_STRATEGIES_MAP[_ctx.campaign.max_spending_per_day_strategy].translate_key)) + ")", 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('revshare')) + ": " + _toDisplayString(_ctx.$n(_ctx.campaign.revshare / 100, 'percent')), 1),
          (_ctx.campaign.comment)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.truncateText(_ctx.campaign.comment, 100)), 1))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}